import React, { useState, useCallback, useRef } from 'react';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import Form from 'react-bootstrap/Form';
import _ from 'underscore';
import CreatableSelect  from "react-select/creatable";
import { components } from "react-select";
import ModalButtons from "../../ModalButtons";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const NameBlock = ({ values: defaultValues = {}, handleNext, libraries = [], JSFlag, title}) => {
    const [values, setValues] = useState(defaultValues);
    const [validated, setValidated] = useState(false);
    const form = useRef(null);

    let libraryNames = [];
    libraries.forEach((item) => {
        libraryNames.push({value: item.name, label: item.name});
    });

    const handleChange = useCallback(newValue => {
        setValues({...values, ...newValue});
    });

    const _handleNext = () => {
        if (form.current.checkValidity() && values.library) {
            if (checkNameAlreadyExists()) {
                setValidated(true);
                return;
            }
            handleNext(values);
        }
        setValidated(true);
    };

    // validate the similary named object already exist in selected library
    let checkNameAlreadyExists = () => {
        let exists = false;
        if (values.library && values.name) {
            let library = libraries.find(item => item.name == values.library);
            if (library && library.blocks) {
                if (library.blocks.find(block => block.name.trim() == values.name.trim()) != null)
                    exists = true;
            }
        }
        return exists;
    }

    return (
        <div className="modal-wrapper">
            <div className={"modal-header"}>
                <h4>{title}</h4>
                <br></br>
                <div className={"icon-active"}>&emsp;</div>
                <div className={"text-description-active"}>Block Details</div>
                <div className={"straight-line"}>———</div>
                <div className={"icon"}>2</div>
                <div className={"text-description"}>Add Inputs</div>
                <div className={"straight-line"}>———</div>
                <div className={"icon"}>3</div>
                <div className={"text-description"}>Assign {JSFlag}</div>
            </div>
            <Form id={"tagsArea"} noValidate validated={validated} className={"bootstrap-override"} onSubmit={_handleNext} ref={form}>
                <Container>
                    <Row className={"mb-3"} id={"block-name-div"}>
                        <Col xs={6}>
                            <Form.Label>Block Name <span style={{color: "red"}}>*</span></Form.Label>
                        </Col>
                        <Col xs={6}>
                            <Form.Control type={"text"}
                                          id={"block-name"}
                                          maxLength={"25"}
                                          required
                                          value={values.name}
                                          autoComplete={"off"}
                                          isInvalid={validated && (!values.name || checkNameAlreadyExists())}
                                          onChange={e => setValues({ ...values, name: e.target.value })}/>
                            <Form.Control.Feedback type={"invalid"}>
                                {checkNameAlreadyExists() ? (
                                    <span>The block with this name already exists</span>
                                ) : (
                                    <span>Please Choose a Valid Name for the Block</span>
                                )}
                            </Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row className={"mb-3"} id={"save-to-library"}>
                        <Col xs={6}>
                            <Form.Label>Save to Library <span style={{color: "red"}}>*</span></Form.Label>
                        </Col>
                        <Col xs={6}>
                            <CreatableSelect
                                defaultValue={values.library ? { label: values.library, value: values.library } : null}
                                className={validated && !values.library && 'is-invalid'}
                                id={"libraries-dropdown"}
                                placeholder={"Select One or Type to Create"}
                                isClearable
                                onChange={valObj => handleChange({ ...values, library: valObj ? valObj.value : valObj})}
                                options={libraryNames}
                                components={{ Input: function customInput(props) {return <components.Input {...props} maxLength={"15"} /> }}}
                                maxMenuHeight={200}
                                classNamePrefix={"inner"}
                                tabSelectsValue={true}
                                noOptionsMessage={() => <span>No Existing Libraries Found. <br/> Please Type a Name to Create a New Library</span>}
                            />
                            <Form.Control.Feedback type={"invalid"}>
                                Please Select a Valid Library
                            </Form.Control.Feedback>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col xs={6}>
                            <Form.Label>Search Keywords</Form.Label><br/>
                            <span className={"footnote"}>Press Enter to Add Keyword.</span>
                        </Col>
                        <Col xs={6}>
                            <TagsInput value={values.keywords || []}
                                       onlyUnique
                                       addKeys={[9, 13, 188, 32]}
                                       onChange={keywords => setValues({ ...values, keywords: _.uniq(keywords, false, _.iteratee(str => str.trim().toLowerCase())) })}
                                       inputProps={{placeholder: '', maxLength: 15}}
                            />
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col xs={6}>
                            <Form.Label>Block Description</Form.Label>
                        </Col>
                        <Col xs={6}>
                            <Form.Control as={"textarea"} id="block-description" value={values.description} maxLength={"500"} onChange={e => setValues({ ...values, description: e.target.value })}/>
                        </Col>
                    </Row>
                </Container>
            </Form>
            <div className={"modal-footer"}>
                <ModalButtons step={1} back={null} next={_handleNext} />
            </div>
        </div>
    );
};

export default NameBlock;